import React, { useEffect, useState } from 'react';
import './Orders.scss';
import { miniApp } from '@telegram-apps/sdk-react';
import { useNavigate } from "react-router-dom";
import { useMainButton } from '../../hooks/useMainButton';
import { useBackButtonManager } from '../../contexts/BackButtonContext';
import { useCart } from '../../contexts/CartContext';
import OrderStatus from '../../components/ui/OrderStatus';
import api from '../../api'; // axios instance
import ApiImage from '../../components/ApiImage';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  const { action, clear } = useBackButtonManager();
  const { setIsEnable } = useCart();

  useEffect(() => {
    window.scrollTo(0, 0);
    miniApp.setBackgroundColor('#161618');
    miniApp.setHeaderColor('#161618');
    action(() => navigate("/"));
    setIsEnable(false);

    // загрузка заказов
    const fetchOrders = async () => {
      try {
        const response = await api.get("/api/orders/UserOrders");
        setOrders(response.data);
      } catch (error) {
        console.error("Ошибка при загрузке заказов:", error);
      }
    };

    fetchOrders();

    return () => {
      setIsEnable(true);
      clear();
      miniApp.setBackgroundColor('#1D1D20');
      miniApp.setHeaderColor('#1D1D20');
    };
  }, []);

  useMainButton();

  return (
    <div className="orders-page page-classes">
      <h2>Заказы</h2>
      {orders.map((order, index) => (
        <div className="order-card" onClick={() => {navigate(`/order/${order.id}`)}} key={index}>
          <div className="order-header">
            <div className="order-date">Заказ от {order.date}</div>
            <div className="order-id">{order.id}</div>
          </div>
          <div className="order-body">
            <div className='order-total-status'>
              <div className="order-total">{order.total}</div>
              <OrderStatus status={order.status} />
            </div>
            <div className="order-images">
              {order.images.map((src, i) => (
                <ApiImage key={i} path={src}></ApiImage>
              ))}
              {order.extraCount > 0 && (
                <div className="order-more">+{order.extraCount}</div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Orders;
